import { render } from "./historyDBC.vue?vue&type=template&id=0b6a395e&scoped=true"
import script from "./historyDBC.vue?vue&type=script&lang=js"
export * from "./historyDBC.vue?vue&type=script&lang=js"

import "./historyDBC.vue?vue&type=style&index=0&id=0b6a395e&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6a395e"]])

export default __exports__